// extracted by mini-css-extract-plugin
export default {"info":"tweet-info_info__pwvjB","infoLink":"tweet-info_infoLink__VOFYH","infoIcon":"tweet-info_infoIcon__lJBD3"};